export class CipCodeSearchResult {
	public cipCode: string;
	public title: string;

	constructor (rowData: any) {
		this.cipCode = rowData.cipCode;
		this.title = rowData.title;
	}

	get entryFormat (): string {
		return `${this.cipCode} - ${this.title}`;
	}
}
